/**
 * External dependencies
 */
import {
	withBlockStyles,
	withUniqueClass,
} from '~cartzillagb/higher-order'

// import {
// 	appendImportant,
// } from '~cartzillagb/util'

import {
	BlockContainer,
} from '~cartzillagb/components'

import { i18n } from 'cartzillagb'
import classnames from 'classnames'
import createStyles from './style'

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import { applyFilters } from '@wordpress/hooks'
import {
	InnerBlocks,
	RichText,
} from '@wordpress/block-editor'
import { compose } from '@wordpress/compose'

const save = props => {
	const {
		className,
		attributes,
	} = props

	const {
		blockId,
		enableContainer,
		bannerTitle,
		bannerLinkText,
		bannerLinkURL,
		bannerAlignRight,
		enableImage,
		mediaURL,

		bgColor,
		customBgColor,

		// Carousel Options
		slidesPerRowTablet,
		infinite,
	} = attributes

	const mainClasses = classnames( [
		'mb-4',
		'pb-3',
		'pb-sm-0',
		'mb-sm-5',
		className,
		enableContainer ? 'container' : '',
	], applyFilters( 'cartzillagb.banner-with-products-carousel.main-block.classes', {}, props ) )

	const defaultCarouselOptions = applyFilters( 'cartzillagb.banner-with-products-carousel.main-block.classes', {
		slidesPerRow: 3,
		slidesToScroll: 1,
		rows: 2,
		dots: false,
		arrows: true,
		adaptiveHeight: true,
		prevArrow: '<i class="czi-arrow-left"></i>',
		nextArrow: '<i class="czi-arrow-right"></i>',
		customArrows: '.cz-custom-controls',
		speed: 500,
		pauseOnHover: true,
		responsive: [
			{
				breakpoint: 991.98,
				settings: {
					slidesPerRow: 2,
				}
			},
		],
	}, props )

	let carouselOptions = {
		rows: 2,
		slidesPerRow: attributes.slidesPerRow,
		responsive: [
			{
				breakpoint: 991.98,
				settings: {
					slidesPerRow: slidesPerRowTablet,
				}
			},
		],
	}

	const blockAttributes = { ...attributes }

	if( infinite === false ) {
		carouselOptions.infinite = false
	} else {
		delete blockAttributes.infinite
	}

	carouselOptions = { ...defaultCarouselOptions, ...carouselOptions }

	const sliderWraperAttr = {}

	sliderWraperAttr.className = classnames( [
		'cz-carousel',
		'cz-controls-static',
	] )

	const bgStyle = { backgroundColor: customBgColor && customBgColor }

	return (
		<BlockContainer.Save className={ mainClasses } blockProps={ { ...props, attributes:{ ...blockAttributes, anchor: blockId } } } data-slick-classes="js-slick-carousel" data-slick-attributes={ JSON.stringify( carouselOptions ) } render={ () => (
			<div className={ 'row' }>
				<div className={ `col-md-5${ bannerAlignRight ? ' order-md-2' : '' }` }>
					<div className={ `d-flex flex-column h-100 overflow-hidden rounded-lg ${ customBgColor ? '' : ( bgColor ? bgColor : 'bg-secondary' ) }` } style={ bgStyle }>
						<div className={ `d-flex justify-content-between px-grid-gutter py-grid-gutter` }>
							<div className={ `banner-text${ bannerAlignRight ? ' order-md-2' : '' }` }>
								<RichText.Content
									tagName="h3"
									className="mb-1"
									value={ bannerTitle }
								/>
								<RichText.Content
									tagName="a"
									href={ bannerLinkURL }
									className="banner-link-text font-size-md"
									value={ bannerLinkText }
								/>
								<i className="czi-arrow-right font-size-xs align-middle ml-1"></i>
							</div>
							<div className={ 'cz-custom-controls' }></div>
						</div>
						{ enableImage &&
							<a href={ bannerLinkURL } className="d-none d-md-block mt-auto banner-text">
								<img src={ mediaURL } className={ `d-block w-100` } alt={ __( 'Banner Image', i18n ) } />
							</a>
						}
					</div>
				</div>
				<div className={ 'col-md-7 pt-4 pt-md-0' }>
					<div { ...sliderWraperAttr }>
						<InnerBlocks.Content />
					</div>
				</div>
			</div>
		) } />
	)
}

export default compose(
	withUniqueClass,
	withBlockStyles( createStyles ),
)( save )